module.exports = __webpack_public_path__ + "img/debtPayingAbility1.acad09d1.png";